// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const pnf: CountryValidator<"BG"> = createValidator(
  "bg.pnf",
  22,
);

export default pnf;
export const compact = pnf.compact;
export const format = pnf.format;
export const validate = pnf.validate;
export const generate = (): string =>
  pnf.generate?.() ??
  (() => {
    throw new Error(
      "Validator bg.pnf cannot generate values",
    );
  })();
